import {useCallback, useEffect, useState} from 'react';
import {getPortalDashboardData} from './DashboardService';
import {normalizePortalDashboard} from './dashboardUtils';

const createInitialState = () => ({
    metrics: [],
    systems: [],
    activities: [],
    notifications: [],
    failedSections: [],
});

export function usePortalDashboard() {
    const [data, setData] = useState(createInitialState);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const loadDashboard = useCallback(async () => {
        setLoading(true);
        setError('');

        try {
            const responses = await getPortalDashboardData();
            const normalized = normalizePortalDashboard(responses);
            setData(normalized);
            if (normalized.failedSections.length) {
                setError('Algumas informações do dashboard não puderam ser carregadas.');
            }
        } catch {
            setData(createInitialState());
            setError('Não foi possível carregar o dashboard.');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadDashboard();
    }, [loadDashboard]);

    return {
        ...data,
        loading,
        error,
        reload: loadDashboard,
    };
}
